import React from "react";

export const Separator = () => (
  <div className="w-full h-full border-b-2 border-dotted border-gray-300 dark:border-gray-700"></div>
);
